export default "__VITE_ASSET__BvMqvBKX__"